import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { removeCatalogOtherCostVariableGroupGql } from '../CatalogVariableGroupQueries';

export const useRemoveVariableGroup = ({ id, updateGroupList }: { id: number; updateGroupList: () => void }) => {
    const dispatch = useDispatch();

    const [resetRemoveData] = useResetStoreData({ requestId: 'removeCatalogOtherCostVariableGroup' });

    const tempSuccessHandler = useCallback(() => {
        updateGroupList();
        resetRemoveData(undefined);
    }, [resetRemoveData, updateGroupList]);

    const [, , , removeOtherVariableGroupRequest] = useRequest({
        requestId: 'removeCatalogOtherCostVariableGroup',
        query: removeCatalogOtherCostVariableGroupGql,
        withEffect: false,
        dependenciesUpdater: tempSuccessHandler,
    });

    return useCallback(() => {
        dispatch(removeOtherVariableGroupRequest({ groupId: id }));
    }, [dispatch, removeOtherVariableGroupRequest, id]);
};
